
import { gsap } from 'gsap';
import { SplitText } from "gsap/SplitText";
import { Elastic } from 'gsap';

gsap.registerPlugin(SplitText);


export class TitleElastic {

	wrapper: HTMLElement;
	chars: any;

	constructor(el: HTMLElement) {
		this.wrapper = el;

		this.splitText();
		this.animate();
	}



	splitText() {
		const mySplitText = new SplitText(this.wrapper, { type: 'chars' });
		this.chars = mySplitText.chars; //an array of all the divs that wrap each character
	}

	animate() {

		const delay = ( this.wrapper.dataset.delay ? parseFloat(this.wrapper.dataset.delay) : 0 );

		const fromProps = {
			opacity: 0,
			// FROM BOTTOM TO TOP
			// y: 90,
			x: -40,
			ease: 'elastic.out(1.1,0.3)'
		};

		const toProps = {
			duration: 2,
			opacity: 1,
			// FROM BOTTOM TO TOP
			// y: 0,
			x: 0,
			stagger: 0.03,
			delay: 0,
			ease: 'elastic.out(1.1,0.3)'
		};

		if ( delay ) {
			toProps.delay = delay;
		}

		gsap.fromTo(this.chars, fromProps, toProps);

		this.wrapper.classList.add('animation-done');
	}

}

